import React from "react";
import PropTypes from "prop-types";
import {
  Form,
  FormGroup,
  FormInput,
  FormTextarea,
} from "../../components/ui";
import dayjs from "dayjs";
import { Modal, ModalHeader, ModalBody } from "../../components/ui";
import NotificationService from "../../components/alerts/index";
import { handleApiError } from "../../utils/apiErrorHandler";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./Invoicestyles.scss";
import {
  getPaymentAllCards,
  getAllEnabledProductsBilling,
  getInvoiceState,
  getSubscriptionStatus,
  getPaymentHistory,
  deletePaymentCard,
  Postcancelplan,
  createPaymentCard,
  renewOrBuySubscription,
  renewSubscription,
  reEnableSubscription,
  changePaymentMode,
  changeWallet,
} from "../../api";
import NFTPage from "../../views/NFTPage";
import withStorage from "../common/WithStorage";
import { withRouter } from "../../hooks/withRouter";
import MaskedInput from "react-text-mask";
import PlansCardsFiterable from "./PlansCardsFilterable";
import ToolbarSelect from "../common/ToolbarSelect/ToolbarSelect";
import logo from "../../images/bitcoin-live/logo.png";
import "./Billing.scss";

const BillingSpinnerIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);

/** Strike the list price only when the next charge is actually lower. */
const getRenewalPrice = (subscriptionRow) => {
  const listPrice = Number(subscriptionRow?.product?.cost);
  const nextPrice = Number(subscriptionRow?.subscription?.nextRenewal?.cost);
  const hasList = Number.isFinite(listPrice);
  const hasNext = Number.isFinite(nextPrice);
  const strikePrice =
    hasList && hasNext && listPrice > nextPrice ? listPrice : null;
  return { listPrice, nextPrice, strikePrice };
};

class Billing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      cardInfo: null,
      isLoading: true,
      history: [],
      modal: false,
      planModal: false,
      cardModal: false,
      cardModalMode: "add",
      showModal: false,
      paymentMethodId: null,
      btcPaymentDialog: false,
      showCancelModal: false,
      showReactivateModal: false,
      isReactivating: false,
      isCancelling: false,
      isConfirmingPurchase: false,
      planChangeError: false,
      planChangeErrorMessage: "",
      showPlans: true,
      disabled: false,
      selectedplanId: "",
      couponId: "",
      selectedPlanDiscountedCost: null,
      lastPurchaseSummary: null,
      openInvoice: false,
      bill: "",
      billaddress: "",
      transactionList: "",
      total: "",
      totalDiscount: "",
      showContent: false,
      refunds: "",
      subTotal: "",
      ownerId: "",
    };
    this.purchasePlansRef = React.createRef();
  }

  openPurchasePlans = () => {
    this.setState({ planModal: true }, () => {
      this.scrollToPurchasePlans();
    });
  };

  scrollToPurchasePlans = () => {
    requestAnimationFrame(() => {
      const section = this.purchasePlansRef.current;
      if (!section) {
        return;
      }

      section.scrollIntoView({ behavior: "smooth", block: "start" });
      section.setAttribute("tabindex", "-1");
      section.focus({ preventScroll: true });
    });
  };

  toggleModal = () => {
    const closing = this.state.planChangeOk;
    this.setState({
      planChangeOk: !this.state.planChangeOk,
      ...(closing
        ? {
            lastPurchaseSummary: null,
            selectedplanId: "",
            couponId: "",
            selectedPlanDiscountedCost: null,
          }
        : {}),
    });
  };

  buildPurchaseSummary = (planId = this.state.selectedplanId) => {
    const plan = (this.state.products || []).find(
      (p) => String(p.id) === String(planId)
    );
    const card = this.state.cardInfo?.cards?.[0];
    const usesBitcoin =
      String(planId) === "5" || this.state.paymentMethodId === 2;
    const charged =
      this.state.selectedPlanDiscountedCost != null &&
      this.state.selectedPlanDiscountedCost !== ""
        ? this.state.selectedPlanDiscountedCost
        : plan?.cost;

    return {
      planName: plan?.name || "Membership",
      charged,
      coupon: this.state.couponId || null,
      payLabel: usesBitcoin
        ? "Bitcoin"
        : card?.last4
        ? `${card.brand || "Card"} •••• ${card.last4}`
        : "Credit card",
    };
  };

  togglePlanModal = () => {
    this.setState({
      planModal: !this.state.planModal,
    });
  };

  openCardModal = (mode = "add") => {
    this.setState({
      cardModal: true,
      cardModalMode: mode === "update" ? "update" : "add",
      cardError: false,
      cardErrorInfo: "",
    });
  };

  closeCardModal = () => {
    this.setState({ cardModal: false });
  };

  toggleCardModal = () => {
    if (this.state.cardModal) {
      this.closeCardModal();
      return;
    }
    const hasCard = Boolean(this.state.cardInfo?.cards?.length);
    this.openCardModal(hasCard ? "update" : "add");
  };

  componentDidMount = async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      this.setState({ user: user });
      const cards = await getPaymentAllCards(user.id);
      const subscription = await getSubscriptionStatus(user.id);
      const paymentHistory = await getPaymentHistory(
        user.id,
        subscription && subscription.data[0].product.id
      );
      const products = await getAllEnabledProductsBilling();
      this.setState(
        {
          cardInfo: cards.data,
          history: paymentHistory.data,
          subscription: subscription.data,
          products: products.data,
          discount: (() => {
            const price = getRenewalPrice(subscription.data[0]);
            return price.strikePrice != null ? price.listPrice : "";
          })(),
          paymentMethodId:
            subscription?.data?.[0].subscription?.nextRenewal
              ?.paymentMethodId === 5
              ? 2
              : subscription?.data?.[0].subscription?.nextRenewal
                  ?.paymentMethodId,
          currentProduct: subscription?.data?.[0].product,
          isLoading: false,
        },
        () => {
          if (this.isEnded()) {
            this.openPurchasePlans();
          }
        }
      );
    }
  };

  refreshData = async () => {
    const { user } = this.state;
    const cards = await getPaymentAllCards(user.id);
    const subscription = await getSubscriptionStatus(user.id);
    const paymentHistory = await getPaymentHistory(
      user.id,
      subscription && subscription.data[0].product.id
    );
    const products = await getAllEnabledProductsBilling();
    this.setState({
      cardInfo: cards.data,
      history: paymentHistory.data,
      subscription: subscription.data,
      products: products.data,
      paymentMethodId:
        subscription.data[0].subscription.nextRenewal.paymentMethodId === 5
          ? 2
          : subscription.data[0].subscription.nextRenewal.paymentMethodId,
      currentProduct: subscription?.data?.[0].product,
      discount: (() => {
        const price = getRenewalPrice(subscription.data[0]);
        return price.strikePrice != null ? price.listPrice : "";
      })(),
      isLoading: false,
    });
  };

  addCard = async () => {
    let user = this.props.load("user");
    const previousCardId = this.state.cardInfo?.cards?.[0]?.id;
    const data = {
      number: this.state.ccNumber.replace(/\s+/g, ""),
      expirationDate: `20${
        this.state.ccExpiration && this.state.ccExpiration.slice(3, 5)
      }-${this.state.ccExpiration && this.state.ccExpiration.slice(0, 2)}`,
      cvc: this.state.ccCVV,
    };
    const createPayment = await createPaymentCard(user.id, data);
    if (createPayment && createPayment.status >= 200 && createPayment.status < 300) {
      // Single-card model: replace previous card when one was already on file.
      if (previousCardId) {
        await deletePaymentCard(user.id, previousCardId);
      }
      const cards = await getPaymentAllCards(user.id);
      this.setState({
        cardInfo: cards.data,
        cardModal: false,
        cardError: false,
        cardErrorInfo: "",
        paymentMethodId: 1,
      });
    } else {
      const errorResponse = handleApiError(createPayment, "Failed to add card");
      this.setState({
        cardError: true,
        cardErrorInfo: errorResponse.message,
      });
    }
  };

  payWithBtc = async () => {
    const data = {
      productId: this.state.subscription[0].product.id,
      paymentMethodId: 2, // bitcoin,
      targetUserId: this.state.user.id,
    };
    if (this.state.discount) {
      data["couponName"] = this.state.coupon;
    }
    const sub = await renewOrBuySubscription(this.state.user.id, data);
    if (sub.data && sub.data.url) {
      this.setState({
        btcPaymentDialog: true,
        btcPaymentUrl: sub.data.url,
      });
    }
  };

  renewPlan = async (newPlanId, coupon) => {
    this.setState({
      showModal: false,
      planChangeError: false,
      isLoading: true,
      lastPurchaseSummary: this.buildPurchaseSummary(newPlanId),
    });
    if (this.state.paymentMethodId === 2) {
      this.setState({
        btcPaymentDialog: true,
        planModal: true,
        isLoading: false,
      });
    }
    const data = {
      productId: newPlanId,
      paymentMethodId: this.state.paymentMethodId
        ? this.state.paymentMethodId
        : this.state.subscription.data[0].subscription.nextRenewal
            .paymentMethodId,
      targetUserId: this.state.user.id,
    };
    if (coupon) {
      data["couponName"] = coupon;
    }
    const sub = await renewSubscription(
      this.state.subscription[0].subscription.id,
      data
    );
    if (sub && sub.status >= 200 && sub.status < 300) {
      const getUrl = await getInvoiceState(sub.data.paymentKey);
      if (getUrl.data && getUrl.data.redirectUrl) {
        this.setState({
          btcPaymentUrl: getUrl.data.redirectUrl,
        });
        const intervalId = setInterval(async () => {
          const invoiceStatus = await getInvoiceState(sub.data.paymentKey);
          if (invoiceStatus.data.paymentStatusId === 5) {
            this.setState({
              planChangeOk: true,
              planModal: false,
              isLoading: false,
              selectedplanId: "",
              couponId: "",
            });
            this.refreshData();
            clearInterval(intervalId);
          }
          if (invoiceStatus.data.paymentStatusId === 4) {
            NotificationService.error(invoiceStatus.data.error);
            this.setState({
              planChangeOk: false,
              planModal: false,
              isLoading: false,
              selectedplanId: "",
              couponId: "",
            });
            this.refreshData();
            clearInterval(intervalId);
          }
        }, 1500);
      }
    } else {
      const errorResponse = handleApiError(sub, "Failed to renew subscription");
      this.setState({
        planChangeError: true,
        planChangeErrorMessage: errorResponse.message,
        isLoading: false,
        selectedplanId: "",
        couponId: "",
      });
    }
  };

  changePlan = async (newPlanId, coupon) => {
    if (this.state.isConfirmingPurchase) {
      return;
    }
    this.setState({
      planChangeError: false,
      planChangeErrorMessage: "",
      isConfirmingPurchase: true,
      lastPurchaseSummary: this.buildPurchaseSummary(newPlanId),
    });

    const data = {
      productId: newPlanId,
      paymentMethodId: this.state.paymentMethodId
        ? this.state.paymentMethodId
        : this.state.subscription.data[0].subscription.nextRenewal
            .paymentMethodId,
      targetUserId: this.state.user.id,
    };

    if (coupon) {
      data["couponName"] = coupon;
    }
    const sub = await renewOrBuySubscription(this.state.user.id, data);
    if (sub && sub.status >= 200 && sub.status < 300) {
      const getUrl = await getInvoiceState(sub.data.paymentKey);
      if (getUrl.data) {
        const hasBtcRedirect = !!getUrl.data.redirectUrl;
        // BTC takes over in its own dialog; card payments keep confirm open with loading.
        this.setState({
          btcPaymentUrl: hasBtcRedirect ? getUrl.data.redirectUrl : null,
          btcPaymentDialog: hasBtcRedirect,
          planModal: true,
          showModal: !hasBtcRedirect,
          isConfirmingPurchase: !hasBtcRedirect,
          isLoading: false,
        });
        const intervalId = setInterval(async () => {
          const invoiceStatus = await getInvoiceState(sub.data.paymentKey);
          if (invoiceStatus.data.paymentStatusId === 5) {
            this.setState({
              btcPaymentDialog: false,
              planChangeOk: true,
              planModal: false,
              showModal: false,
              isConfirmingPurchase: false,
            });
            this.refreshData();
            clearInterval(intervalId);
          } else if (
            invoiceStatus &&
            invoiceStatus.data.paymentStatusId === 4
          ) {
            clearInterval(intervalId);
            this.setState({
              planChangeError: true,
              planChangeOk: false,
              planChangeErrorMessage: invoiceStatus.data.error,
              isConfirmingPurchase: false,
              isLoading: false,
              btcPaymentDialog: false,
              showModal: true,
              planModal: true,
            });
            NotificationService.error(invoiceStatus.data.error);
          }
        }, 1500);
      } else {
        this.setState({
          isConfirmingPurchase: false,
          planChangeError: true,
          planChangeErrorMessage:
            "Unable to start payment. Please try again.",
        });
      }
    } else {
      const errorResponse = handleApiError(sub, "Failed to process subscription");
      this.setState({
        planChangeError: true,
        planChangeErrorMessage: errorResponse.message,
        isConfirmingPurchase: false,
      });
    }
  };

  cancelPlan = async () => {
    if (this.state.isCancelling) {
      return;
    }
    this.setState({ isCancelling: true });
    try {
      const resp = await Postcancelplan(
        this.state.subscription[0].subscription.id
      );
      if (resp && resp.status === 200) {
        this.setState({ showCancelModal: false, isCancelling: false });
        this.refreshData();
        NotificationService.success("Success");
      } else {
        const errorResponse = handleApiError(
          resp,
          "Failed to cancel subscription"
        );
        this.setState({ isCancelling: false });
        NotificationService.error(errorResponse.message);
      }
    } catch (e) {
      this.setState({ isCancelling: false });
      NotificationService.error("Failed to cancel subscription");
    }
  };

  selectPlan = (productId) => {
    this.setState({
      newPlanId: productId,
    });
  };

  changeRenewalMethod = async () => {
    const payload = {
      renewalPaymentMethodId: 1,
    };
    const data = await changePaymentMode(
      payload,
      this.state.subscription[0].subscription.id
    );
    if (data.status === 200) {
      this.refreshData();
      NotificationService.success("Payment Method changed");
    }
  };

  changePaymentMethod = (valOrEvent) => {
    const val =
      typeof valOrEvent === "string"
        ? valOrEvent
        : valOrEvent?.target?.value;
    if (val === "newcard") {
      this.setState({ paymentMethodId: 1 });
      this.openCardModal("add");
      return;
    }
    this.setState({
      paymentMethodId: val === "bitcoin" ? 2 : 1,
    });
  };

  resolveStatus = (statusId) => {
    switch (statusId) {
      case 1:
        return "Active";
      case 2:
        return "Overdue";
      case 3:
        return "Cancelled";
      case 4:
        return "Ended";
      default:
        return "";
    }
  };

  getStatusColor = (statusId) => {
    switch (statusId) {
      case 1:
        return "billing-status billing-status--active";
      case 2:
        return "billing-status billing-status--overdue";
      case 3:
        return "billing-status billing-status--cancelled";
      case 4:
        return "billing-status billing-status--ended";
      default:
        return "billing-status";
    }
  };

  onPlanClick = (newPlanId, coupon, discountedCost = null) => {
    this.setState({
      paymentMethodId:
        newPlanId === 5 && this.state.paymentMethodId !== 2
          ? 2
          : this.state.paymentMethodId,
      showModal: true,
      selectedplanId: newPlanId,
      couponId: coupon,
      selectedPlanDiscountedCost:
        discountedCost != null && discountedCost !== ""
          ? discountedCost
          : null,
    });
  };

  isEnded = () => {
    return (
      this.state.subscription &&
      this.state.subscription[0].subscription.statusId === 4
    );
  };

  isPendingCancelation = () => {
    return this.state.subscription[0].subscription.statusId === 3;
  };

  reEnableSubscriptionForUser = async () => {
    this.setState({ isReactivating: true });
    const resp = await reEnableSubscription(
      this.state.user.id,
      this.state.subscription[0].subscription.id
    );
    if (resp && resp.status >= 200 && resp.status < 300) {
      this.setState({
        showReactivateModal: false,
        isReactivating: false,
      });
      this.refreshData();
      NotificationService.success("Subscription re-enabled successfully");
    } else {
      const errorResponse = handleApiError(resp, "Failed to re-enable subscription");
      this.setState({ isReactivating: false });
      NotificationService.error(errorResponse.message);
    }
  };

  printDocument = () => {
    const name = this.state.user && this.state.user.name;
    const input = document.getElementById("pdfDownload");
    html2canvas(input, { useCORS: true, scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      var doc = new jsPDF("p", "mm");
      var imgWidth = 210;
      var pageHeight = 295;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      var position = 0;
      doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save(`${name}(Invoice).pdf`);
      this.setState({ openInvoice: false, showContent: false });
    });
  };

  openInvoice = () => {
    const cost = [];
    const discount = [];
    const refund = [];
    const rawTotal = [];
    this.state.history.map((data) => {
      if (data.refundedAmount === undefined) {
        cost.push(data.amount);
        rawTotal.push(data.product.cost);
        discount.push(data.discount);
        refund.push(data.refundedAmount !== undefined && data.refundedAmount);
      }
    });
    this.setState({
      total: cost.reduce((a, b) => a + b, 0),
      totalDiscount: discount.reduce((a, b) => a + b, 0),
      refunds: refund.reduce((a, b) => a + b, 0),
      subTotal: rawTotal.reduce((a, b) => a + b, 0),
      openInvoice: true,
    });
  };

  confirmPrint = () => {
    this.setState({ showContent: true });
    setTimeout(() => {
      this.printDocument();
    }, 1000);
  };

  validateNFTPayment = () => {
    const validateNFT = (this.state.subscription || []).map((data) => {
      if (
        data.subscription.nextRenewal.paymentMethodId === 5 &&
        data.product.id === 5
      ) {
        return true;
      } else {
        return false;
      }
    });
    const filteredData = [...new Set(validateNFT.filter((data) => data))];
    return filteredData[0] || false;
  };

  handleConnectWallet = async (ownerId) => {
    // Prevent repeated API calls for the same address
    if (!ownerId || ownerId === this.state.ownerId) return;
    this.setState({ ownerId });
    const data = {
      walletAddress: ownerId,
    };
    const resp = await changeWallet(data);
    if (resp.status === 422) {
      NotificationService.error(resp.data.error);
    } else if (resp.status === 500) {
      NotificationService.error(resp.data.error || "Something went wrong");
    } else {
      if (resp.status === 200) {
        this.refreshData();
      }
    }
  };

  getQueryParams() {
    const { location } = this.props;
    if (location.pathname.includes("connectWallet")) {
      return true;
    } else {
      return false;
    }
  }

  paymentMethodLabel = (paymentMethodId) => {
    // History rows must not borrow the live card last4 (legacy: "Credit Card" only)
    if (paymentMethodId === 1) return "Credit Card";
    if (paymentMethodId === 2) return "Bitcoin";
    if (paymentMethodId === 3) return "Complimentary";
    if (paymentMethodId === 4) return "Manual";
    if (paymentMethodId === 5) return "NFT";
    return "—";
  };

  formatAmount = (amount) => {
    const n = Number(amount);
    if (Number.isNaN(n)) return amount != null ? `$${amount}` : "—";
    return `$${n.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  render() {
    const subscription = this.state.subscription?.[0];
    const subscriptionStatusId = subscription?.subscription?.statusId;
    const nextRenewal = subscription?.subscription?.nextRenewal;
    const showPaymentCol =
      subscription && subscriptionStatusId !== 3;
    const isUpdatingCard = this.state.cardModalMode === "update";
    const existingCardLast4 = this.state.cardInfo?.cards?.[0]?.last4;
    const selectedPlan = (this.state.products || []).find(
      (p) => String(p.id) === String(this.state.selectedplanId)
    );
    const confirmUsesBitcoin =
      String(this.state.selectedplanId) === "5" ||
      this.state.paymentMethodId === 2;
    const cardBrand = this.state.cardInfo?.cards?.[0]?.brand;
    const confirmPayLabel = confirmUsesBitcoin
      ? "Bitcoin"
      : existingCardLast4
      ? `${cardBrand || "Card"} •••• ${existingCardLast4}`
      : "Credit card";
    const confirmHasDiscount =
      this.state.couponId &&
      this.state.selectedPlanDiscountedCost != null &&
      selectedPlan &&
      Number(this.state.selectedPlanDiscountedCost) !== Number(selectedPlan.cost);
    const confirmPlanInterval = (() => {
      const cycle = selectedPlan?.billingCycle;
      if (cycle === 12 || cycle === 365) return "per year";
      if (cycle === 1 || cycle === 30) return "per month";
      if (cycle === 3 || cycle === 92) return "per quarter";
      if (cycle === 65535) return "one-time";
      return "";
    })();
    const confirmPlanLabel = (() => {
      if (!selectedPlan) return "";
      const name = selectedPlan.name || "";
      const key = name.toLowerCase();
      const interval = confirmPlanInterval;
      const redundant =
        !interval ||
        (key.includes("month") && interval === "per month") ||
        (key.includes("quarter") && interval === "per quarter") ||
        ((key.includes("annual") || key.includes("year")) &&
          interval === "per year") ||
        (key.includes("lifetime") && interval.includes("one"));
      return redundant ? name : `${name} · ${interval}`;
    })();
    const confirmTitle = selectedPlan
      ? `Confirm your ${String(selectedPlan.name).toLowerCase()} membership`
      : this.isEnded()
      ? "Confirm purchase"
      : "Confirm upgrade";
    const confirmBody = this.isEnded()
      ? "Review the details below before continuing."
      : "You’ll be charged today. Unused days on your current plan carry over to the new one.";
    const confirmCta = this.isEnded() ? "Purchase" : "Confirm and pay";
    const purchase = this.state.lastPurchaseSummary;

    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.planChangeOk}
          toggle={this.toggleModal}
          className="billing-modal billing-modal--success"
          centered
        >
          <ModalHeader
            className="billing-modal__header"
            toggle={this.toggleModal}
          >
            You&apos;re all set
          </ModalHeader>
          <ModalBody>
            <p className="billing-modal__text billing-modal__text--left billing-success__lead">
              {purchase?.planName
                ? `Your ${purchase.planName} membership is active — member content and alerts are unlocked.`
                : "Your payment has been successfully processed."}
            </p>

            <div className="billing-success">
              <span className="billing-success__icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  width="28"
                  height="28"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </span>

              {purchase && (
                <div className="billing-success__summary">
                  <div className="billing-success__row">
                    <span className="billing-success__label">Charged</span>
                    <span className="billing-success__value">
                      ${purchase.charged}
                    </span>
                  </div>
                  <div className="billing-success__row">
                    <span className="billing-success__label">Paid with</span>
                    <span className="billing-success__value">
                      {purchase.payLabel}
                    </span>
                  </div>
                  {purchase.coupon ? (
                    <div className="billing-success__row">
                      <span className="billing-success__label">
                        Coupon applied
                      </span>
                      <span className="billing-confirm-summary__chip">
                        {purchase.coupon}
                      </span>
                    </div>
                  ) : null}
                </div>
              )}

              <p className="billing-success__note">
                This purchase will appear in your transaction history.
              </p>

              <div className="billing-modal__actions billing-modal__actions--end">
                <button
                  type="button"
                  className="billing-btn billing-btn--primary"
                  onClick={this.toggleModal}
                >
                  Done
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.cardModal}
          toggle={this.closeCardModal}
          className="billing-modal billing-modal--card"
          centered
          size="md"
        >
          <ModalHeader
            className="billing-modal__header"
            toggle={this.closeCardModal}
          >
            {isUpdatingCard ? "Update credit card" : "Add new credit card"}
          </ModalHeader>
          <ModalBody>
            <p className="billing-modal__text billing-modal__text--left">
              {isUpdatingCard
                ? existingCardLast4
                  ? `Replace the card on file (•••• ${existingCardLast4}) for renewals. Your details are processed securely.`
                  : "Replace the card on file for renewals. Your details are processed securely."
                : "Save a card for subscription renewals. Your details are processed securely."}
            </p>
            <form
              className="billing-card-form"
              onSubmit={(e) => {
                e.preventDefault();
                this.addCard();
              }}
            >
              <FormGroup className="form-group">
                <label htmlFor="billing-cc-holder">Card holder</label>
                <FormInput
                  id="billing-cc-holder"
                  type="text"
                  className="form-control"
                  placeholder="Name on card"
                  onChange={(text) =>
                    this.setState({ ccHolder: text.target.value })
                  }
                />
              </FormGroup>
              <FormGroup className="form-group">
                <label htmlFor="billing-cc-number">Card number</label>
                <MaskedInput
                  id="billing-cc-number"
                  type="text"
                  className="form-control"
                  mask={[
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    " ",
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    " ",
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    " ",
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                    /[0-9]/,
                  ]}
                  placeholder="0000 0000 0000 0000"
                  guide={false}
                  onChange={(text) =>
                    this.setState({ ccNumber: text.target.value })
                  }
                />
              </FormGroup>
              <div className="billing-card-form__row">
                <FormGroup className="form-group">
                  <label htmlFor="billing-cc-expiry">Expiration</label>
                  <MaskedInput
                    id="billing-cc-expiry"
                    className="form-control"
                    type="text"
                    guide={false}
                    mask={[/[0-9]/, /[0-9]/, "/", /[0-9]/, /[0-9]/]}
                    placeholder="MM/YY"
                    onChange={(text) =>
                      this.setState({ ccExpiration: text.target.value })
                    }
                  />
                </FormGroup>
                <FormGroup className="form-group">
                  <label htmlFor="billing-cc-cvc">CVC</label>
                  <MaskedInput
                    id="billing-cc-cvc"
                    className="form-control"
                    mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]}
                    type="text"
                    guide={false}
                    placeholder="000"
                    onChange={(text) =>
                      this.setState({ ccCVV: text.target.value })
                    }
                  />
                </FormGroup>
              </div>
              {this.state.cardError && (
                <div className="billing-card-form__error" role="alert">
                  {this.state.cardErrorInfo}
                </div>
              )}
              <div className="billing-modal__actions billing-modal__actions--end">
                <button
                  type="button"
                  className="billing-btn billing-btn--outline"
                  onClick={this.closeCardModal}
                >
                  Cancel
                </button>
                <button type="submit" className="billing-btn billing-btn--primary">
                  {isUpdatingCard ? "Update card" : "Add card"}
                </button>
              </div>
            </form>
          </ModalBody>
        </Modal>
        {this.state.isLoading && !subscription ? (
          <div className="billing-loading" role="status" aria-live="polite">
            <BillingSpinnerIcon />
            <p>Loading your billing details…</p>
          </div>
        ) : (
          <div className="billing-lovable-wrap">
            {this.state.isLoading ? (
              <div className="billing-loading-overlay" role="status" aria-live="polite">
                <div className="billing-loading billing-loading--overlay">
                  <BillingSpinnerIcon />
                  <p>Updating…</p>
                </div>
              </div>
            ) : null}
          <div className="billing-page billing-page--lovable">
            {/* 1. Current plan */}
            <section className="billing-section billing-section--plan">
              <div className="billing-section__top">
                <div>
                  <h2 className="billing-section__title">Current plan</h2>
                  <p className="billing-section__desc">
                    {this.state?.currentProduct?.name
                      ? subscriptionStatusId === 4
                        ? `${this.state.currentProduct.name} (expired)`
                        : this.state.currentProduct.name
                      : "Your membership details and renewal information."}
                  </p>
                </div>
                {subscription && (
                  <span className={this.getStatusColor(subscriptionStatusId)}>
                    {this.resolveStatus(subscriptionStatusId)}
                  </span>
                )}
              </div>

              {subscriptionStatusId === 4 && (
                <div className="billing-alert billing-alert--danger" role="status">
                  Renew your plan today — choose a plan below.
                </div>
              )}

              <div className="billing-stats">
                {showPaymentCol && nextRenewal && (
                  <div className="billing-stat">
                    <span className="billing-stat__label">
                      {subscriptionStatusId === 4
                        ? "Plan price"
                        : nextRenewal.paymentMethodId === 3
                        ? "Cost"
                        : "Next payment"}
                    </span>
                    <p className="billing-stat__value">
                      {(() => {
                        const isComplimentary = nextRenewal.paymentMethodId === 3;
                        if (isComplimentary && subscriptionStatusId !== 4) {
                          return "Complimentary";
                        }
                        const price = getRenewalPrice(
                          this.state.subscription[0]
                        );
                        if (subscriptionStatusId === 3) {
                          return "—";
                        }
                        const amount =
                          subscriptionStatusId === 4
                            ? price.strikePrice != null
                              ? price.nextPrice
                              : price.listPrice
                            : nextRenewal.cost;
                        return (
                          <>
                            {price.strikePrice != null && !isComplimentary && (
                              <span className="discount">
                                ${price.strikePrice}
                              </span>
                            )}
                            {`$${amount}`}
                          </>
                        );
                      })()}
                    </p>
                  </div>
                )}

                {subscriptionStatusId === 4 && nextRenewal?.date && (
                  <div className="billing-stat">
                    <span className="billing-stat__label">Access ended</span>
                    <p className="billing-stat__value">
                      {dayjs(nextRenewal.date).format("MMMM D, YYYY")}
                    </p>
                  </div>
                )}

                {subscription && nextRenewal && subscriptionStatusId !== 4 && (
                  <div className="billing-stat">
                    <span className="billing-stat__label">
                      {subscriptionStatusId === 3
                        ? "Access until"
                        : nextRenewal.paymentMethodId === 3 && nextRenewal.date
                        ? "Ends"
                        : "Next renewal"}
                    </span>
                    <p className="billing-stat__value">
                      {nextRenewal.paymentMethodId === 3 && !nextRenewal.date
                        ? "Complimentary subscription"
                        : nextRenewal.date
                        ? dayjs(nextRenewal.date).format("MMMM D, YYYY")
                        : "—"}
                    </p>
                  </div>
                )}

                {(subscriptionStatusId === 3 || subscriptionStatusId === 4) &&
                  subscription?.subscription?.cancellationDate && (
                  <div className="billing-stat">
                    <span className="billing-stat__label">Cancelled on</span>
                    <p className="billing-stat__value">
                      {dayjs(
                        subscription.subscription.cancellationDate
                      ).isValid()
                        ? dayjs(
                            subscription.subscription.cancellationDate
                          ).format("MMMM D, YYYY")
                        : subscription.subscription.cancellationDate}
                    </p>
                  </div>
                )}
              </div>

              <div className="billing-actions">
                {this.isEnded() && !this.getQueryParams() && (
                  <button
                    type="button"
                    className="billing-btn billing-btn--primary"
                    onClick={this.openPurchasePlans}
                  >
                    Renew plan
                  </button>
                )}
                {subscription &&
                  subscription.product.id !== 1 &&
                  subscription.product.id !== 5 &&
                  !this.isEnded() &&
                  !this.isPendingCancelation() &&
                  !this.getQueryParams() && (
                    <button
                      type="button"
                      className="billing-btn billing-btn--primary"
                      onClick={this.openPurchasePlans}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
                        <path d="M20 3v4" />
                        <path d="M22 5h-4" />
                        <path d="M4 17v2" />
                        <path d="M5 18H3" />
                      </svg>
                      Upgrade plan
                    </button>
                  )}
                {subscriptionStatusId === 1 &&
                  subscription.subscription.isCancellable &&
                  !this.getQueryParams() && (
                    <button
                      type="button"
                      className="billing-btn billing-btn--outline"
                      onClick={() => {
                        this.setState({ showCancelModal: true });
                      }}
                    >
                      Cancel plan
                    </button>
                  )}
                {subscription &&
                  this.isPendingCancelation() &&
                  !this.getQueryParams() && (
                    <button
                      type="button"
                      className="billing-btn billing-btn--primary"
                      onClick={() =>
                        this.setState({ showReactivateModal: true })
                      }
                    >
                      Re-activate plan
                    </button>
                  )}
              </div>

              {(this.getQueryParams() ||
                (subscriptionStatusId === 4 && this.validateNFTPayment())) && (
                <div className="billing-wallet">
                  <div className="billing-wallet__intro">
                    <span className="billing-wallet__icon" aria-hidden="true">
                      <svg
                        viewBox="0 0 24 24"
                        width="20"
                        height="20"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4" />
                        <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
                        <circle cx="17" cy="12" r="1" fill="currentColor" stroke="none" />
                      </svg>
                    </span>
                    <div>
                      <p className="billing-wallet__title">
                        Lifetime / NFT access
                      </p>
                      <p className="billing-wallet__desc">
                        Connect the wallet holding your membership NFT to verify
                        ownership.
                      </p>
                    </div>
                  </div>
                  <NFTPage
                    setownerId={(value) => {
                      if (value !== "") {
                        this.handleConnectWallet(value);
                      }
                      this.setState({ ownerId: value });
                    }}
                  />
                </div>
              )}
            </section>

            {/* 2. Payment method — Lovable select + summary panel */}
            <section className="billing-section billing-section--payment">
              <h2 className="billing-section__title">Payment method</h2>
              <p className="billing-section__desc">
                Choose how your membership is charged.
              </p>

              {subscription && (
                <div className="billing-payment-lovable">
                  <div className="billing-payment-lovable__field">
                    <label htmlFor="billing-payment-method">Method</label>
                    <ToolbarSelect
                      id="billing-payment-method"
                      className="billing-method-select"
                      aria-label="Payment method"
                      value={
                        this.state.paymentMethodId === 1
                          ? "cc"
                          : this.state.paymentMethodId === 2
                          ? "bitcoin"
                          : ""
                      }
                      triggerLabel={
                        !this.state.paymentMethodId ? "Choose…" : undefined
                      }
                      onChange={this.changePaymentMethod}
                      options={[
                        { value: "bitcoin", label: "Bitcoin" },
                        ...(this.state.cardInfo?.cards?.length
                          ? [{ value: "cc", label: "Credit Card" }]
                          : [
                              { value: "newcard", label: "Add new card" },
                            ]),
                      ]}
                    />
                  </div>

                  {this.state.paymentMethodId === 1 &&
                  this.state.cardInfo?.cards?.length ? (
                    <div className="billing-pay-summary">
                      <div className="billing-pay-summary__left">
                        <span className="billing-pay-summary__icon" aria-hidden="true">
                          <svg
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect width="20" height="14" x="2" y="5" rx="2" />
                            <line x1="2" x2="22" y1="10" y2="10" />
                          </svg>
                        </span>
                        <div>
                          <p className="billing-pay-summary__title">
                            {this.state.cardInfo.cards[0].brand || "Card"}{" "}
                            •••• •••• •••• {this.state.cardInfo.cards[0].last4}
                          </p>
                          <p className="billing-pay-summary__meta">
                            {this.state.cardInfo.cards[0].expMonth
                              ? `Expires ${String(
                                  this.state.cardInfo.cards[0].expMonth
                                ).padStart(2, "0")}/${String(
                                  this.state.cardInfo.cards[0].expYear
                                ).slice(-2)}`
                              : "Saved payment method"}
                          </p>
                        </div>
                      </div>
                      <div className="billing-pay-summary__actions">
                        <button
                          type="button"
                          className="billing-btn billing-btn--outline billing-btn--sm"
                          onClick={() => this.openCardModal("update")}
                        >
                          Update card
                        </button>
                        {nextRenewal?.paymentMethodId === 2 &&
                          !this.isEnded() &&
                          !this.isPendingCancelation() && (
                            <button
                              type="button"
                              className="billing-btn billing-btn--outline billing-btn--sm"
                              onClick={() => this.changeRenewalMethod()}
                            >
                              Apply credit card
                            </button>
                          )}
                      </div>
                    </div>
                  ) : this.state.paymentMethodId === 2 ? (
                    <div className="billing-pay-summary">
                      <div className="billing-pay-summary__left">
                        <span className="billing-pay-summary__icon" aria-hidden="true">
                          <svg
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727" />
                          </svg>
                        </span>
                        <div>
                          <p className="billing-pay-summary__title">Bitcoin</p>
                          <p className="billing-pay-summary__meta">
                            An invoice is generated each renewal.
                          </p>
                        </div>
                      </div>
                      {!this.isEnded() && !this.isPendingCancelation() && (
                        <button
                          type="button"
                          className="billing-btn billing-btn--outline billing-btn--sm"
                          onClick={() =>
                            this.renewPlan(this.state.currentProduct.id)
                          }
                        >
                          Renew with Bitcoin
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="billing-pay-summary billing-pay-summary--empty">
                      <p className="billing-pay-summary__meta">
                        No payment method selected yet.
                      </p>
                      <button
                        type="button"
                        className="billing-btn billing-btn--primary billing-btn--sm"
                        onClick={() => this.openCardModal("add")}
                      >
                        Add card
                      </button>
                    </div>
                  )}
                </div>
              )}
            </section>

            {/* 3. Purchase / upgrade — prod: only when planModal */}
            {this.state.planModal && (
              <section
                ref={this.purchasePlansRef}
                className="billing-section billing-section--purchase"
                aria-label="Purchase plan"
              >
                <h2 className="billing-section__title">Purchase plan</h2>
                <p className="billing-section__desc">
                  {this.isEnded()
                    ? "Choose a plan to restore your membership."
                    : "Upgrading? Any unused days on your current plan carry over to the new one."}
                </p>

                {subscription &&
                  !this.state.btcPaymentDialog &&
                  this.state.showPlans && (
                    <div className="billing-plans-embed">
                      <PlansCardsFiterable
                        actionText={this.isEnded() ? "PURCHASE" : "UPGRADE"}
                        filterForProduct={subscription.product.id}
                        isEnded={this.isEnded()}
                        changePlan={this.onPlanClick}
                      />
                    </div>
                  )}
                {this.state.btcPaymentDialog && (
                  <div className="billing-btc-frame">
                    <div className="billing-btc-frame__head">
                      <span className="billing-pay-summary__icon" aria-hidden="true">
                        <svg
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727" />
                        </svg>
                      </span>
                      <div>
                        <p className="billing-wallet__title">
                          Waiting for your Bitcoin payment
                        </p>
                        <p className="billing-wallet__desc">
                          Complete payment in the invoice below. This updates
                          automatically when confirmed.
                        </p>
                      </div>
                    </div>
                    <iframe
                      src={this.state.btcPaymentUrl}
                      className="billing-btc-frame__iframe"
                      title="btc"
                    />
                  </div>
                )}
              </section>
            )}

            {/* 4. Transaction history — Lovable table + single Download receipt */}
            <section className="billing-section billing-section--history">
              <div className="billing-history__toolbar">
                <div className="billing-history__intro">
                  <h2 className="billing-section__title">Transaction history</h2>
                  <p className="billing-section__desc">
                    Every membership payment on your account.
                  </p>
                </div>
                {(this.state.history || []).length > 0 && (
                  <button
                    type="button"
                    className="billing-btn billing-btn--outline billing-btn--sm"
                    onClick={() => this.openInvoice()}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" x2="12" y1="15" y2="3" />
                    </svg>
                    Download receipt
                  </button>
                )}
              </div>

              <div className="billing-history__scroll">
                {(this.state.history || []).length === 0 ? (
                  <p className="billing-history__empty">
                    No transactions yet.
                  </p>
                ) : (
                  <table className="billing-history__table">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Amount paid</th>
                        <th>Payment method</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.history.map((row, index) => (
                        <tr key={row.id || index}>
                          <td className="billing-history__product">
                            {row.product?.name || "—"}
                          </td>
                          <td className="billing-history__amount">
                            <span>{this.formatAmount(row.amount)}</span>
                            {row.refundedAmount != null &&
                            row.refundedAmount !== undefined ? (
                              <span className="billing-history__refund">
                                Refunded
                              </span>
                            ) : null}
                          </td>
                          <td className="billing-history__muted">
                            {this.paymentMethodLabel(row.paymentMethodId)}
                          </td>
                          <td className="billing-history__muted">
                            {row.date
                              ? dayjs(row.date).format("MMM D, YYYY")
                              : "—"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </section>
          </div>
          <Modal
            centered
            size="md"
            className="billing-modal billing-modal--confirm"
            isOpen={this.state.showModal}
            toggle={() => {
              if (!this.state.isConfirmingPurchase) {
                this.setState({ showModal: false, planChangeError: false });
              }
            }}
          >
            <ModalHeader
              className="billing-modal__header"
              toggle={() => {
                if (!this.state.isConfirmingPurchase) {
                  this.setState({ showModal: false, planChangeError: false });
                }
              }}
            >
              {confirmTitle}
            </ModalHeader>
            <ModalBody>
              <p className="billing-modal__text billing-modal__text--left">
                {confirmBody}
              </p>

              {selectedPlan && (
                <div className="billing-confirm-summary">
                  <div className="billing-confirm-summary__row">
                    <span className="billing-confirm-summary__label">Plan</span>
                    <span className="billing-confirm-summary__value">
                      {confirmPlanLabel}
                    </span>
                  </div>
                  {this.state.couponId ? (
                    <div className="billing-confirm-summary__row">
                      <span className="billing-confirm-summary__label">
                        Coupon
                      </span>
                      <span className="billing-confirm-summary__chip">
                        {this.state.couponId}
                      </span>
                    </div>
                  ) : null}
                  <div className="billing-confirm-summary__row">
                    <span className="billing-confirm-summary__label">
                      Payment method
                    </span>
                    <span className="billing-confirm-summary__value">
                      {confirmPayLabel}
                    </span>
                  </div>
                  <div className="billing-confirm-summary__row billing-confirm-summary__row--total">
                    <span className="billing-confirm-summary__label">
                      Total due today
                    </span>
                    <span className="billing-confirm-summary__total-wrap">
                      {confirmHasDiscount ? (
                        <>
                          <span className="billing-confirm-summary__original">
                            ${selectedPlan.cost}
                          </span>
                          <span className="billing-confirm-summary__total">
                            ${this.state.selectedPlanDiscountedCost}
                          </span>
                        </>
                      ) : (
                        <span className="billing-confirm-summary__total">
                          ${selectedPlan.cost}
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              )}

              {this.state.planChangeError && this.state.planChangeErrorMessage ? (
                <p className="billing-modal__error" role="alert">
                  {this.state.planChangeErrorMessage}
                </p>
              ) : null}

              <div className="billing-modal__actions billing-modal__actions--end">
                <button
                  type="button"
                  className="billing-btn billing-btn--ghost"
                  disabled={this.state.isConfirmingPurchase}
                  onClick={() =>
                    this.setState({ showModal: false, planChangeError: false })
                  }
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="billing-btn billing-btn--primary"
                  disabled={this.state.isConfirmingPurchase}
                  onClick={() => {
                    this.changePlan(
                      this.state.selectedplanId,
                      this.state.couponId
                    );
                  }}
                >
                  {this.state.isConfirmingPurchase
                    ? "Processing…"
                    : confirmCta}
                </button>
              </div>
            </ModalBody>
          </Modal>
          <Modal
            centered
            size="md"
            className="billing-modal billing-modal--cancel"
            isOpen={this.state.showCancelModal}
            toggle={() => {
              if (!this.state.isCancelling) {
                this.setState({ showCancelModal: false });
              }
            }}
          >
            <ModalHeader
              className="billing-modal__header"
              toggle={() => {
                if (!this.state.isCancelling) {
                  this.setState({ showCancelModal: false });
                }
              }}
            >
              Cancel your subscription?
            </ModalHeader>
            <ModalBody>
              <p className="billing-modal__text billing-modal__text--left">
                {nextRenewal?.date
                  ? `You’ll keep full member access until ${dayjs(
                      nextRenewal.date
                    ).format(
                      "MMM D, YYYY"
                    )}. After that your account switches to free content only.`
                  : "You’ll keep access until the end of your current billing period. After that your account switches to free content only."}
              </p>
              <div className="billing-modal__actions billing-modal__actions--end">
                <button
                  type="button"
                  className="billing-btn billing-btn--ghost"
                  disabled={this.state.isCancelling}
                  onClick={() => this.setState({ showCancelModal: false })}
                >
                  Keep my plan
                </button>
                <button
                  type="button"
                  className="billing-btn billing-btn--danger"
                  disabled={this.state.isCancelling}
                  onClick={() => {
                    this.cancelPlan();
                  }}
                >
                  {this.state.isCancelling
                    ? "Cancelling…"
                    : "Cancel subscription"}
                </button>
              </div>
            </ModalBody>
          </Modal>
          <Modal
            centered
            size="md"
            className="billing-modal"
            isOpen={this.state.showReactivateModal}
            toggle={() => {
              if (!this.state.isReactivating) {
                this.setState({ showReactivateModal: false });
              }
            }}
          >
            <ModalHeader
              className="billing-modal__header"
              toggle={() => {
                if (!this.state.isReactivating) {
                  this.setState({ showReactivateModal: false });
                }
              }}
            >
              Re-activate subscription?
            </ModalHeader>
            <ModalBody>
              <p className="billing-modal__text">
                Your <strong>{this.state.currentProduct?.name}</strong> plan is
                currently cancelled
                {nextRenewal?.date && (
                  <>
                    {" "}
                    with access until{" "}
                    <strong>
                      {dayjs(nextRenewal.date).format("MMMM D, YYYY")}
                    </strong>
                  </>
                )}
                . Re-activating will resume automatic renewals on your saved
                payment method.
              </p>
              <div className="billing-modal__actions">
                <button
                  type="button"
                  className="billing-btn billing-btn--secondary"
                  disabled={this.state.isReactivating}
                  onClick={() => this.setState({ showReactivateModal: false })}
                >
                  Not now
                </button>
                <button
                  type="button"
                  className="billing-btn billing-btn--primary"
                  disabled={this.state.isReactivating}
                  onClick={this.reEnableSubscriptionForUser}
                >
                  {this.state.isReactivating
                    ? "Re-activating…"
                    : "Re-activate plan"}
                </button>
              </div>
            </ModalBody>
          </Modal>
          <Modal
            centered
            size="md"
            className="billing-modal"
            isOpen={this.state.openInvoice}
            toggle={() => {
              this.setState({ openInvoice: false });
            }}
          >
            <ModalHeader
              className="billing-modal__header"
              toggle={() => {
                this.setState({ openInvoice: false });
              }}
            >
              Download receipt
            </ModalHeader>
            <ModalBody>
              <p className="billing-modal__text">
                Enter billing details for your transaction receipt.
              </p>
              <Form>
                <FormGroup className="form-group">
                  <label htmlFor="billing-receipt-name">Billing name</label>
                  <FormInput
                    id="billing-receipt-name"
                    type="text"
                    placeholder="Your name"
                    value={this.state.bill}
                    onChange={(e) => {
                      this.setState({ bill: e.target.value });
                    }}
                  />
                </FormGroup>
                <FormGroup className="form-group">
                  <label htmlFor="billing-receipt-address">Address</label>
                  <FormTextarea
                    id="billing-receipt-address"
                    placeholder="Billing address (optional)"
                    value={this.state.billaddress}
                    onChange={(e) => {
                      this.setState({ billaddress: e.target.value });
                    }}
                  />
                </FormGroup>
              </Form>
              <div className="billing-modal__actions">
                <button
                  type="button"
                  className="billing-btn billing-btn--primary"
                  onClick={() => {
                    this.confirmPrint();
                  }}
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" x2="12" y1="15" y2="3" />
                  </svg>
                  Download PDF
                </button>
              </div>
            </ModalBody>
          </Modal>
          {this.state.showContent ? (
            <div id="pdfDownload" className="invoice-pdf-source">
              {/* Header */}
              <div className="invoice-header">
                <div className="invoice-header__brand">
                  <img className="invoice-header__logo" src={logo} alt="Bitcoin Live" />
                  <div className="invoice-header__company">
                    <span className="invoice-header__name">Bitcoin Live</span>
                    <span className="invoice-header__address">26 Broadway, New York, NY 10004</span>
                  </div>
                </div>
                <div className="invoice-header__meta">
                  <span className="invoice-header__title">Invoice</span>
                  <span className="invoice-header__date">{dayjs().format("MMMM D, YYYY")}</span>
                </div>
              </div>

              {/* Billing details */}
              <div className="invoice-parties">
                <div className="invoice-parties__block">
                  <span className="invoice-parties__label">Bill To</span>
                  <span className="invoice-parties__value">{this.state.bill || "—"}</span>
                </div>
                <div className="invoice-parties__block">
                  <span className="invoice-parties__label">Ship To</span>
                  <span className="invoice-parties__value">
                    {this.state.billaddress || "Digital Product"}
                  </span>
                </div>
              </div>

              {/* Line items */}
              <table className="invoice-table" cellPadding="0" cellSpacing="0">
                <thead>
                  <tr>
                    <th style={{width: "8%"}}>Qty</th>
                    <th style={{width: "32%"}}>Description</th>
                    <th style={{width: "22%"}}>Date</th>
                    <th style={{width: "18%"}}>Discount</th>
                    <th style={{width: "20%", textAlign: "right"}}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.history.length > 0
                    ? this.state.history.map((data, idx) => (
                        <tr key={idx}>
                          <td>1</td>
                          <td>{`Bitcoin Live Subscription — ${data.product.name}`}</td>
                          <td>{dayjs(data.date).format("MMM D, YYYY")}</td>
                          <td>
                            {data.refundedAmount !== undefined
                              ? `${data.refundedAmount} [Refund]`
                              : `$${data.discount} USD`}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {`$${data.amount} USD`}
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              </table>

              {/* Totals */}
              <table className="invoice-totals" cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td className="invoice-totals__label">Subtotal</td>
                    <td className="invoice-totals__value">{`$${this.state.subTotal} USD`}</td>
                  </tr>
                  <tr>
                    <td className="invoice-totals__label">Discount</td>
                    <td className="invoice-totals__value">{`−$${this.state.totalDiscount} USD`}</td>
                  </tr>
                  <tr className="invoice-totals__grand">
                    <td className="invoice-totals__label">Total</td>
                    <td className="invoice-totals__value">{`$${this.state.subTotal - this.state.totalDiscount} USD`}</td>
                  </tr>
                </tbody>
              </table>

              {/* Footer */}
              <div className="invoice-footer">
                <span>Thank you for your business!</span>
              </div>
            </div>
          ) : (
            ""
          )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

Billing.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
};

Billing.defaultProps = {};

export default withStorage(withRouter(Billing));
